import i18n from "i18next";
import type { FC } from "react";
import { useDispatch } from "react-redux";

import { useCampaignMutation } from "src/app/features/Campaign/services/server/CampaignApi";
import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";
import { ButtonEvents } from "../../../../../components/Buttons/ButtonEvents";
import { GenericConfirmationPrimaryButton } from "../../../../../components/Buttons/components/GenericConfirmationPrimaryButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import { showSuccessNotification } from "../../../../../core/setup/redux/state/notifications/notificationsState";

export const GenerateButton: FC<ButtonProps<CampaignEntity>> = ({ isDisabled, item, items, onReload }) => {
    const dispatch = useDispatch();
    const [request, { isLoading }] = useCampaignMutation();

    const callBackend = () => {
        const notifyOk = () => {
            dispatch(
                showSuccessNotification({
                    text: i18n.t("success.campaign.generate.successfully", { 0: item?.id }),
                    autoCloseDisabled: false,
                }),
            );
        };

        const groupCode = getAssignedDataGroup()?.code;
        const baseURI = `${ResourceName.DATA_GROUPS}/${groupCode}`;

        request({
            url: `${baseURI}/${ResourceName.CAMPAIGNS}/${item?.id}/${FORM_ACTION.GENERATE}`,
        })
            .unwrap()
            .then(() => {
                notifyOk();
                onReload?.();
            })
            .catch(() => {
                // error handled in rtkQueryErrorLogger
            });
    };

    const isOnlyOneCreated = items?.length === 1 && item?.state === "CREATED";
    // disabled while the request is in flight; on success onReload clears the selection
    const isDisabledFinal = isDisabled || !isOnlyOneCreated || isLoading;

    return (
        <GenericConfirmationPrimaryButton
            modalTitle="campaignEditForm.generateCampaign"
            modalBody="campaign.generateModal.text"
            isDisabled={isDisabledFinal}
            translationKey="campaignEditForm.generateCampaign"
            params={{ name: item?.name }}
            item={item || {}}
            onClickCallback={() => {
                callBackend();
                return item || {};
            }}
            onClickEventName={ButtonEvents.ADD}
            name="generate_button"
            className="aevi-button aevi-button-primary"
        />
    );
};
